import { accountAccess } from "./accountAccess";

// Describe verified access, never the outcome of a payment URL.
export function subscriptionPresentation(sub, now = Date.now()) {
  const access = accountAccess(sub, now);
  const premium = access.allowed && ["active", "canceled"].includes(access.status);
  const labelKey = access.accountType === "pilot" ? "acc.accessPilot" :
    access.status === "trialing" ? "acc.accessTrial" : premium ? "acc.accessPremium" :
    access.status === "expired" ? "acc.accessExpired" : access.status === "past_due" ? "acc.accessPastDue" : "acc.accessNone";
  const noticeKey = access.accountType === "pilot" ? "acc.pilotPermanent" :
    access.status === "trialing" ? "sub.trialNotice" : premium ? "sub.premiumNotice" :
    access.status === "expired" ? "sub.expiredNotice" : "sub.unavailableNotice";
  const rawEnd = access.accountType === "pilot" ? null : sub?.status === "trialing" ? sub.trialEndsAt : premium ? sub.currentPeriodEnd : null;
  const endsAt = rawEnd && Number.isFinite(new Date(rawEnd).getTime()) ? rawEnd : null;
  return { ...access, premium, labelKey, noticeKey, endsAt,
    dateKey: sub?.status === "trialing" ? "acc.trialUntil" : "sub.accessUntil" };
}
